module.exports = __webpack_public_path__ + "media/images/icons/outlined/calculator-af8f2d9d93dae7a5136f8603eb108baf.svg";